export default "__VITE_ASSET__Da7ysowS__"